
// (function Showpic1() {
// 	document.getElementById("image").src = "/sites/default/files/2024-06/disaster-chopper_v2.jpg";
// })();
// (function Showpic2() {
// 	document.getElementById("image").src = "/sites/default/files/2024-05/mimosa-receiver.jpeg";
// })();




(function ($, Drupal) {

	'use strict';
	// Sticky main navbar when scrolled
	var position = $(window).scrollTop();
	$(window).scroll(function () {
		if ($(this).scrollTop() > 25) {
			$('.navbar').addClass("navbar-scrolled");
		}
		else {
			$('.navbar').removeClass("navbar-scrolled");
		}
	});
	// End sticky main navbar when scrolled
	// Make submenu full browser width.
	$(window).on("load resize", function () {
		submenuFullwidthCalc();
	});
	const submenuFullwidthCalc = function () {
		// Get the Mega menu Level 1 sub menu.
		$(".tb-megamenu-nav > .level-1 > .tb-megamenu-submenu").each(function () {
			// reset to zero so it can be calculated again and again
			$(this).css("left", 0);
			const offsettarget = $("body").offset();
			// The offset of this submenu.
			const offsetthis = $(this)
				.parent()
				.offset();
			// Calculate the offset.
			$(this).css("left", offsettarget.left - offsetthis.left);
			// Set the submenu full width.
			$(this).css("width", $("body").width());
		});
	}
	// End Make submenu full browser width.

	$(document).ready(function () {
		$(".accordion-header").click(function (event) {
			var $target = $(this).attr('id');
			var $id = $target.slice(-3);
			$('.custom-images div').addClass('d-none');
			$('#img_' + $id).removeClass('d-none');

		});

		$(".bg-black-gradient .field__items .col-12").addClass('col-lg');

		// Scroll Back To Top button -- Start
		//Get the button
		let mybutton = document.getElementById("btn-back-to-top");

		// When the user scrolls down 20px from the top of the document, show the button
		window.onscroll = function () {
			scrollFunction();
		};

		function scrollFunction() {
			if (
				document.body.scrollTop > 20 ||
				document.documentElement.scrollTop > 20
			) {
				mybutton.style.display = "block";
			} else {
				mybutton.style.display = "none";
			}
		}
		// When the user clicks on the button, scroll to the top of the document
		if (mybutton) {
			mybutton.addEventListener("click", backToTop);

			function backToTop() {
				document.body.scrollTop = 0;
				document.documentElement.scrollTop = 0;
			}
			// Scroll Back To Top button -- End
		}

		// Start of mimosanetworks Zendesk Widget script



		function toggleModal() {
			$(".c-mimosa-modal--overlay").toggleClass("visible");
			$(".c-mimosa-modal").toggleClass("visible");
		}

		$('a[href="#modal"]').on("click", toggleModal);
		$(".c-mimosa-modal--overlay").on("click", toggleModal);
		$(".c-mimosa-modal__close-button").on("click", toggleModal);

		$zopim(function () {
			var chatOpen = false;
			$zopim.livechat.cookieLaw.comply();
			$zopim.livechat.cookieLaw.setDefaultImplicitConsent();
			//   $zopim.livechat.hideAll();
			$zopim.livechat.departments.setVisitorDepartment("US Sales");
			$zopim.livechat.theme.setColor("#3597e7");
			$zopim.livechat.setGreetings({
				disabled: "Chat with us",
			});

			$("a[href='#openchat']").on("click", function () {
				$zopim.livechat.departments.setVisitorDepartment("Support");
				if (chatOpen) {
					$zopim.livechat.hideAll();
					chatOpen = false;
				} else {
					$zopim.livechat.window.show();
					chatOpen = true;
				}
			});
		});
		//End of mimosanetworks Zendesk Widget script



	});





})(jQuery, Drupal);

